/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Creator_DescriptionInputs */

const en_tier_creator_description = /** @type {(inputs: Tier_Creator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power users running a steady business. Lower fees, higher limits.`)
};

const es_tier_creator_description = /** @type {(inputs: Tier_Creator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuarios avanzados que manejan un negocio estable. Tarifas más bajas, límites más altos.`)
};

const fr_tier_creator_description = /** @type {(inputs: Tier_Creator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisateurs expérimentés gérant une entreprise stable. Frais moins élevés, limites plus importantes.`)
};

const de_tier_creator_description = /** @type {(inputs: Tier_Creator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power-User, die ein stabiles Geschäft betreiben. Niedrigere Gebühren, höhere Limits.`)
};

const ja_tier_creator_description = /** @type {(inputs: Tier_Creator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安定したビジネスを運営するパワーユーザー向け。低い手数料、高い制限枠。`)
};

const zh_tier_creator_description = /** @type {(inputs: Tier_Creator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于稳定经营业务的高级用户。费率更低，额度更高。`)
};

const ar_tier_creator_description = /** @type {(inputs: Tier_Creator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المستخدمون المحترفون الذين يديرون أعمالاً مستقرة. رسوم أقل، وحدود أعلى.`)
};

const id_tier_creator_description = /** @type {(inputs: Tier_Creator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengguna tingkat lanjut yang menjalankan bisnis stabil. Biaya lebih rendah, batas lebih tinggi.`)
};

const it_tier_creator_description = /** @type {(inputs: Tier_Creator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utenti esperti che gestiscono un'attività stabile. Commissioni più basse, limiti più alti.`)
};

const ru_tier_creator_description = /** @type {(inputs: Tier_Creator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для опытных пользователей, ведущих стабильный бизнес. Низкие комиссии, высокие лимиты.`)
};

const pt_tier_creator_description = /** @type {(inputs: Tier_Creator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuários avançados gerenciando um negócio constante. Taxas mais baixas, limites maiores.`)
};

const ko_tier_creator_description = /** @type {(inputs: Tier_Creator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`안정적인 비즈니스를 운영하는 파워 유저. 더 낮은 수수료, 더 높은 한도 제공.`)
};

/**
* | output |
* | --- |
* | "Power users running a steady business. Lower fees, higher limits." |
*
* @param {Tier_Creator_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_creator_description = /** @type {((inputs?: Tier_Creator_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Creator_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_creator_description(inputs)
	if (locale === "es") return es_tier_creator_description(inputs)
	if (locale === "fr") return fr_tier_creator_description(inputs)
	if (locale === "de") return de_tier_creator_description(inputs)
	if (locale === "ja") return ja_tier_creator_description(inputs)
	if (locale === "zh") return zh_tier_creator_description(inputs)
	if (locale === "ar") return ar_tier_creator_description(inputs)
	if (locale === "id") return id_tier_creator_description(inputs)
	if (locale === "it") return it_tier_creator_description(inputs)
	if (locale === "ru") return ru_tier_creator_description(inputs)
	if (locale === "pt") return pt_tier_creator_description(inputs)
	return ko_tier_creator_description(inputs)
});